module.exports = __webpack_public_path__ + "media/customizations/teravalis/logo-new-a465f20fa3ec6ebec427d37ba3c3be15.png";